import * as React from "react";
import { useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import WorkDayHoursForm from "./WorkDayHoursForm";
import api from "../../../../config/api";
import { useAuth } from "../../../../context/ContextApi";
import { useEffect } from "react";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const { userEstablishment } = useAuth();

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function WorkDayTabs() {
  const [value, setValue] = useState(0);
  const [weekDays, setWeekDays] = useState([]);
  const { userEstablishment } = useAuth();
  const segments = new URL(window.location.href).pathname.split("/");
  // Get last url segment
  const professionalId = segments.pop() || segments.pop(); // Handle potential trailing slash
  // console.log('professionalId');
  // console.log(professionalId);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const getWeekDays = async () => {
      const response = await api.get(
        `professional-reserve-hours/?establishment=${userEstablishment}&professional=${professionalId}`
      );
      // console.log('response.data')
      // console.log(response.data)
      setWeekDays(response.data);
    };
    getWeekDays();
  }, [professionalId, userEstablishment, value]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Domingo" />
          <Tab label="Segunda-feira" />
          <Tab label="Terça-feira" />
          <Tab label="Quarta-feira" />
          <Tab label="Quinta-feira" />
          <Tab label="Sexta-feira" />
          <Tab label="Sábado" />
        </Tabs>
      </Box>
      {weekDays.map((weekDay, index) => {
        return (
          <TabPanel value={value} index={index} className="mt-4">
            <WorkDayHoursForm
              startFirst={weekDay.startFirst}
              endFirst={weekDay.endFirst}
              startSecond={weekDay.startSecond}
              endSecond={weekDay.endSecond}
              weekDayId={weekDay._id}
              weekDayIndex={weekDay.weekDay}
            />
          </TabPanel>
        );
      })}
    </Box>
  );
}
